/**
 * The scenes a page may show, each loaded with three.js in its own chunk: a page names one
 * (`<ThreeCanvas :scene="scenes.globe" />`) and pays for nothing until it draws.
 */
export const scenes = {
  globe: () => import('./scenes/globe').then((m) => m.globe),
  shapes: () => import('./scenes/shapes').then((m) => m.shapes),
  ring: () => import('./scenes/ring').then((m) => m.ring),
  sparkle: () => import('./scenes/sparkle').then((m) => m.sparkle),
  network: () => import('./scenes/network').then((m) => m.network),
}
